import {useEffect, useState } from 'react';
import { useLocation } from "react-router-dom";
import AddNewHCO from './new-hco';
import AddNewHCOUS from './new-hco-us';
import ConfirmationDialogRaw1 from '../globalSearch/popupGlobal';
import Storage from '../../session/storage';
import api from '../../service/api';
import ProgressBar from '../progress/progressBar';

const AddNewHCOWithCountry = (props) => {
  const location = useLocation();
  const rest = location.state || {};
  const {country, user, iqviaSource} = rest;
  const [allCountry,setAllCountry] = useState(Storage.getAllCountryList())
  const [showIqviaPopUp, setShowIqviaPopUp] = useState(true)
  const [loading, setLoading]= useState(false)
  useEffect(()=>{
    if(allCountry === null || allCountry === undefined){
      setLoading(true)
      async function fetchDetails() {
        await api.getSelectedDCRCountry().then((countryList) => {
          var countryListData = countryList.data
          Storage.setAllCountryList(countryList.data)
          setAllCountry(countryListData)
          setTimeout(() => {
            setLoading(false);
          }, 4000);
  
  
        }).catch((error) => {
          setLoading(false);
        })
      }
  
      fetchDetails();
    }   
  },[])

  function handleOk(value) {
    setShowIqviaPopUp(false)
  };

  function cancelPopUp(){
      setShowIqviaPopUp(false)
      window.history.back(-1)
    }


  function showComponent(){
    if(allCountry === null || allCountry === undefined){
      props.history.push("/");
    }else{
      if(country === undefined || country === '' || iqviaSource){
        return <ConfirmationDialogRaw1
        id="static-popup"
        open={showIqviaPopUp}
        onOk={(value) => handleOk(value)}
        onCancel={() => cancelPopUp()}
        option={iqviaSource ? ['United States#IQVIA_US'] :allCountry}
        vendor={false}
        entityType={'HCO'}
        specialtyDropDownvalue={Storage.getPickList().specialty_cnt}
        user={user}
        entity={"HCO"}
      />;
      }else{
          if(country !== '' && country === 'United States' && !iqviaSource){
            return <AddNewHCOUS {...rest} option={allCountry}/>
          }else{
            return <AddNewHCO {...rest}/>
          }
      }
    }
  }
  return (
    <>
     {loading && (
        <div className="extra-margin-top d-flex justify-content-center body-height">
          <ProgressBar />
        </div>
      )}
      {!loading && allCountry && showComponent()}
    </>
  )
}

export default AddNewHCOWithCountry
